/** PWA「添加到主屏幕」：安卓可调起安装；iOS 仅能引导手动添加 */

let deferredPrompt = null
const listeners = new Set()

function notify() {
  listeners.forEach((fn) => {
    try {
      fn()
    } catch {
      /* ignore */
    }
  })
}

export function isStandaloneDisplay() {
  try {
    if (window.matchMedia?.('(display-mode: standalone)')?.matches) return true
    if (window.navigator.standalone === true) return true
  } catch {
    /* ignore */
  }
  return false
}

export function isIosDevice() {
  const ua = String(navigator.userAgent || '')
  if (/iPad|iPhone|iPod/.test(ua)) return true
  // iPadOS 13+ 桌面 UA
  if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) return true
  return false
}

export function canNativeInstallPrompt() {
  return !!deferredPrompt
}

export function onPwaInstallAvailabilityChange(fn) {
  listeners.add(fn)
  return () => listeners.delete(fn)
}

export function setupPwaInstallCapture() {
  if (typeof window === 'undefined') return () => {}
  const onBip = (e) => {
    e.preventDefault()
    deferredPrompt = e
    notify()
  }
  window.addEventListener('beforeinstallprompt', onBip)
  window.addEventListener('appinstalled', () => {
    deferredPrompt = null
    notify()
  })
  return () => {
    window.removeEventListener('beforeinstallprompt', onBip)
  }
}

/**
 * @returns {Promise<'accepted'|'dismissed'|'unavailable'|'standalone'|'ios-guide'>}
 */
export async function promptPwaInstall() {
  if (isStandaloneDisplay()) return 'standalone'
  if (isIosDevice()) return 'ios-guide'
  if (!deferredPrompt) return 'unavailable'
  const promptEvent = deferredPrompt
  deferredPrompt = null
  notify()
  try {
    await promptEvent.prompt()
    const choice = await promptEvent.userChoice
    return choice?.outcome === 'accepted' ? 'accepted' : 'dismissed'
  } catch {
    return 'unavailable'
  }
}
